const MAX_INNER_WIDTH = 541;

const isMobile = (innerwidth) => {
    return (innerwidth < MAX_INNER_WIDTH)
}
  
export default isMobile